export default __webpack_public_path__ + "static/media/belier.ec402ea1.jpg";